var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCreditCard = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 64,
  height: 64,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.15,
  x: 10,
  y: 22,
  width: 41,
  height: 28,
  rx: 4,
  fill: "#23B40C",
  className: "credit-card_svg__ColoredSvgPath"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m19.454 14.664 32.393 5.712a2 2 0 0 1 1.622 2.317L51 36.698v8.02c.486-.538.83-1.215.966-1.982L55.44 23.04a4 4 0 0 0-3.245-4.633l-32.393-5.712a4 4 0 0 0-4.633 3.244L14.098 22h2.032l1.007-5.713a2 2 0 0 1 2.317-1.623z",
  fill: "#A1A1A9"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14 24h33a2 2 0 0 1 2 2v1H12v-1a2 2 0 0 1 2-2zm-2 5v4h37v-4H12zm0 17V35h37v11a2 2 0 0 1-2 2H14a2 2 0 0 1-2-2zm-2-20a4 4 0 0 1 4-4h33a4 4 0 0 1 4 4v20a4 4 0 0 1-4 4H14a4 4 0 0 1-4-4V26zm27 12a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2h-8zm0 2h8v4h-8v-4z",
  fill: "#23B40C",
  className: "credit-card_svg__ColoredSvgPath"
})));
export default SvgCreditCard;